import React from 'react'
import {
  Box,
  Chip,
  FormControl,
  InputLabel,
  ListSubheader,
  MenuItem,
  Select,
  Typography,
} from '@mui/material'
import {
  CQC_ACTIVITY_LABEL,
  statementTitle,
} from './cqcLinkage'

// Shared by AddNewRisk and SingleRisk: picks the CQC regulated activity and
// the quality statements a risk evidences. `statements`/`keyQuestions` come
// from useCqcStatements().
const CqcLinkageFields = ({
  activityType,
  onActivityChange,
  statementKeys,
  onStatementKeysChange,
  statements,
  keyQuestions,
  size = 'medium',
}) => {
  const statementMenuItems = keyQuestions.flatMap((kq) => [
    <ListSubheader key={`${kq}-header`} sx={{ fontWeight: 600, color: 'third.main' }}>
      {kq}
    </ListSubheader>,
    ...statements
      .filter((qs) => qs.keyQuestion === kq && qs.isActive !== false)
      .map((qs) => (
        <MenuItem key={qs.key} value={qs.key} dense>
          {qs.title}
        </MenuItem>
      )),
  ])

  return (
    <Box display="flex" flexDirection="column" gap={1.5}>
      <FormControl fullWidth size={size}>
        <InputLabel id="cqc-activity-label">Regulated Activity</InputLabel>
        <Select
          labelId="cqc-activity-label"
          value={activityType ?? ''}
          label="Regulated Activity"
          onChange={(e) => onActivityChange(e.target.value || null)}
        >
          <MenuItem value="">
            <Typography color="text.secondary">Not related to a regulated activity</Typography>
          </MenuItem>
          {Object.entries(CQC_ACTIVITY_LABEL).map(([value, label]) => (
            <MenuItem key={value} value={value}>
              {label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl fullWidth size={size}>
        <InputLabel id="cqc-statements-label">CQC Quality Statements</InputLabel>
        <Select
          labelId="cqc-statements-label"
          multiple
          value={statementKeys ?? []}
          label="CQC Quality Statements"
          onChange={(e) => onStatementKeysChange(e.target.value)}
          renderValue={(selected) => (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
              {selected.map((key) => (
                <Chip
                  key={key}
                  size="small"
                  label={statementTitle(key, statements)}
                  sx={{ borderRadius: 1, fontWeight: 600 }}
                />
              ))}
            </Box>
          )}
        >
          {statementMenuItems}
        </Select>
      </FormControl>

      <Typography variant="caption" color="text.secondary">
        Linked statements decide where this risk appears in the CQC Centre and
        Inspection Pack. Leave empty to use the defaults (Safe &mdash; involving people to
        manage risks, and Responsive &mdash; planning for the future).
      </Typography>
    </Box>
  )
}

export default CqcLinkageFields
